// constants
import { NewGroup } from "constants/global";

// types
import { GroupPermissionItem, PermissionGroup } from "containers/NewGroup/useNewGroup";

export function formatPermissionList(permissionList: GroupPermissionItem[], isDeclarationVerificationSelected?: boolean): PermissionGroup[] {
	const formattedList: PermissionGroup[] = [];

	permissionList?.forEach((curr: GroupPermissionItem) => {
		const existingKeyIndex = formattedList?.findIndex(({ code }: { code?: string }) => code === curr?.perm_group_code);
		const isReimbPermVoucherGrpType = curr?.perm_group_code === NewGroup.DECLARATION_VERIFICATION_PERM_GROUP_CODE;
		const shouldDisableReimVoucherGrp = isReimbPermVoucherGrpType && !isDeclarationVerificationSelected;

		if (existingKeyIndex > -1) {
			formattedList[existingKeyIndex]?.values?.push(curr);
		} else {
			const obj = {
				title: curr.perm_group_desc,
				code: curr.perm_group_code,
				values: [curr],
				disable: shouldDisableReimVoucherGrp
			};
			formattedList.push(obj);
		}
	});
	return formattedList;
}
